module.exports = __webpack_public_path__ + "fonts/ebac3af.woff";